import { getMachineStructureNodeset } from "@src/cloud-connect/dependency-injection-container/get-machine-structure-nodeset";
import { transferConfigurationToClient } from "@src/cloud-connect/node-manager/transfer-configuration-to-client/transfer-configuration-to-client";
import { RootState } from "@src/reducers/store";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

export interface TransferConfigurationToClientButtonObj {
  handleOnClick: () => void;
  activeStyle: string;
  disabled: boolean;
  loading: boolean;
}

export const useTransferConfigurationToClientButtonHook =
  (): TransferConfigurationToClientButtonObj => {
    const machineStructureNodeset = getMachineStructureNodeset();

    const structureHasDuplicateIds = useSelector(
      (state: RootState) => state.yourSlice.duplicateStructureIds,
    );

    const [activeStyle, setActiveStyle] = useState("inactive");
    const [isButtonDisabled, setIsButtonDisabled] = useState(true);
    const [isButtonLoading, setIsButtonLoading] = useState(false);

    useEffect(() => {
      const updateActiveStyle = () => {
        if (
          machineStructureNodeset.getFlatMap() &&
          machineStructureNodeset.getFlatMap().size > 1
        ) {
          setActiveStyle("");
        } else {
          setActiveStyle("inactive");
        }
      };

      const updateDisabled = () => {
        if (
          machineStructureNodeset.getFlatMap() &&
          machineStructureNodeset.getFlatMap().size > 1
        ) {
          setIsButtonDisabled(false);
        } else {
          setIsButtonDisabled(true);
        }
      };

      updateActiveStyle();
      updateDisabled();

      machineStructureNodeset.addObserver(updateActiveStyle);
      machineStructureNodeset.addObserver(updateDisabled);

      return () => {
        machineStructureNodeset.removeObserver(updateActiveStyle);
        machineStructureNodeset.removeObserver(updateDisabled);
      };
    }, [machineStructureNodeset.getFlatMap()]);

    useEffect(() => {
      if (structureHasDuplicateIds.length > 0) {
        setIsButtonDisabled(true);
        setActiveStyle("inactive");
      } else {
        setIsButtonDisabled(false);
        setActiveStyle("");
      }
    }, [structureHasDuplicateIds]);

    return {
      // the boolean value is setting true to overwriteReduxStateWithLastSavedStructure
      // needed because we are staying in the node manager and the user might want to make changes and discard them later on
      // and therefore we need the latest saved structure in redux
      handleOnClick: () =>
        transferConfigurationToClient(true, setIsButtonLoading),
      activeStyle: activeStyle,
      disabled: isButtonDisabled,
      loading: isButtonLoading,
    };
  };
